import { extendTheme } from '@chakra-ui/react';

import styles from './styles';

import fonts from './foundations/fonts';

const overrides = {
  styles,
  fonts,
  components: {
    Modal: {
      sizes: {
        '7xl': {
          dialog: { maxWidth: '80rem' },
        },
      },
    },
    FormLabel: {
      baseStyle: {
        '&[data-disabled]': {
          opacity: 0.5,
          color: 'gray.500',
          cursor: 'not-allowed',
        },
      },
    },
  },
};

export default extendTheme(overrides);
